import React from 'react';
import i18n from '../../i18n';
import Layout from '../../components/Layout';
import Toolbar from "../../components/Toolbar/Toolbar";
import {goBack} from "../../fn/navigation";
import CardContent from "@material-ui/core/CardContent/CardContent";
import Card from "@material-ui/core/Card/Card";

const ContactsShow = ({contact, contactType, backLink, houses}) => (
    <Layout>
        <Toolbar
            disableGutters
            title={contact.is_company ? contact.company_name : contact.first_name + ' ' + contact.last_name}
            items={[
                {
                    icon: 'arrow_back_ios',
                    text: i18n.get('contacts.back'),
                    href: backLink,
                    onClick: (event) => {
                        event.preventDefault();
                        goBack(backLink);
                    },
                    color: 'secondary',
                },
                {
                    icon: 'edit',
                    text: i18n.get('contacts.edit'),
                    href: `/contacts/${contactType}/${contact.id}/edit`,
                }
            ]}
        />

        <Card>
            <CardContent>
                <ContactDetails contact={contact} houses={houses}/>
            </CardContent>
        </Card>
    </Layout>
);

export default ContactsShow;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/contacts/Show.jsx